import axios from 'axios';
import { apis } from 'utils/constants';

const getHeaders = async () => {
  if (!localStorage.getItem('token')) {
    const startIndex = window.location.href.lastIndexOf('/') + 1;
    const token = window.location.href.slice(startIndex);
    return {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    };
  } else {
    const token = await localStorage.getItem('token');
    return {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    };
  }
};

const getQueryParams = (params) => {
  let ret = [];
  for (const k in params) {
    if (params[k]) {
      ret.push(`${k}=${encodeURIComponent(params[k])}`);
    }
  }
  return ret.join('&');
};

const doRequest = async (requestParams) => {
  /* eslint-disable-next-line no-console */
  // console.log(JSON.stringify(requestParams, null, 2));

  let {
    method,
    url,
    params,
    contentType,
    responseType,
    skipAuth,
    skipLoading,
  } = requestParams;

  // skipAuth가 true면 인증 헤더 없이 요청
  const getRequestHeaders = async () => {
    if (skipAuth) {
      return {
        'Content-Type': 'application/json; charset=utf-8',
      };
    }
    return await getHeaders();
  };

  let ret = null;
  try {
    if (method === 'get') {
      if (responseType === 'blob') {
        ret = await axios.get(`${url}?${getQueryParams(params)}`, {
          withCredential: true,
          headers: await getRequestHeaders(),
          responseType: 'blob',
          skipLoading,
        });
      } else {
        ret = await axios.get(`${url}?${getQueryParams(params)}`, {
          withCredential: true,
          headers: await getRequestHeaders(),
          skipLoading,
        });
      }
    } else if (method === 'post') {
      if (contentType === 'multipart/form-data') {
        const headers = await getRequestHeaders();
        ret = await axios.post(url, params, {
          withCredential: true,
          headers: {
            ...headers,
            'Content-Type': 'multipart/form-data',
            accept: 'application/json',
          },
          skipLoading,
        });
      } else {
        ret = await axios.post(url, params, {
          withCredential: true,
          headers: await getRequestHeaders(),
          skipLoading,
        });
      }
    } else if (method === 'put') {
      ret = await axios.put(url, params, {
        withCredential: true,
        headers: await getRequestHeaders(),
        skipLoading,
      });
    } else if (method === 'del') {
      ret = await axios.delete(url, {
        withCredential: true,
        headers: await getRequestHeaders(),
        params,
        skipLoading,
      });
    } else {
      throw new Error(`Not Implemented`);
    }
    /* eslint-disable-next-line no-console */
    // console.log(ret.data);
    // if (ret.data.statusCode === 401) {
    //   localStorage.clear();
    //   window.open(`${apis.url}/login`, '_self');
    // }
    return ret.data;
  } catch (e) {
    /* eslint-disable-next-line no-console */
    // console.log(JSON.stringify(requestParams, null, 2));
    /* eslint-disable-next-line no-console */
    // console.log(JSON.stringify(e.response?.data || {}, null, 2));
    throw e;
  }
};

const postAccountSignup = async (params) => {
  return await doRequest({
    method: `post`,
    url: `${apis.account.signup}`,
    params: params,
  });
};

const postAccountSignin = async (params) => {
  return await doRequest({
    method: `post`,
    url: `${apis.account.signin}`,
    params: params,
  });
};

const getAccountUser = async (params) => {
  return await doRequest({
    method: `get`,
    url: `${apis.account.user}`,
    params: params,
  });
};

const postAccountCheckPassword = async (params) => {
  return await doRequest({
    method: `post`,
    url: `${apis.account.password.check}`,
    params: params,
  });
};

const postAccountUpdatePassword = async (params) => {
  return await doRequest({
    method: `post`,
    url: `${apis.account.password.update}`,
    params: params,
  });
};

const postAccountGeneratePassword = async (params) => {
  return await doRequest({
    method: `post`,
    url: `${apis.account.password.generate}`,
    params: params,
  });
};

const postAccountGeneratePasswordToken = async (params) => {
  return await doRequest({
    method: `post`,
    url: `${apis.account.password.generate}${params.token}`,
    params: params,
  });
};

const delAccountDelete = async (params) => {
  return await doRequest({
    method: `del`,
    url: `${apis.account.delete}`,
    params: params,
  });
};

const getEstateDataList = async (params) => {
  return await doRequest({
    method: `get`,
    url: `${apis.data.analysis.estate.list}`,
    params: params,
  });
};

const getEstateAddrList = async (params) => {
  return await doRequest({
    method: `get`,
    url: `${apis.data.analysis.estate.addr}`,
    params: params,
  });
};

const getEstateDate = async (params) => {
  return await doRequest({
    method: `get`,
    url: `${apis.data.analysis.estate.date}`,
    params: params,
  });
};

// 새로운 Auth API 함수들 (인증 불필요)
const postAuthSignup = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.auth.signup}`,
    params: params,
    skipAuth: true,
  });
};

const postAuthSignin = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.auth.signin}`,
    params: params,
    skipAuth: true,
  });
};

const postAuthCheckEmail = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.auth.checkEmail}`,
    params: params,
    skipAuth: true,
  });
};

const postAuthPasswordReset = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.auth.password.reset}`,
    params: params,
    skipAuth: true,
  });
};

const postAuthPasswordChange = async (token, params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.auth.password.change}/${token}`,
    params: params,
    skipAuth: true,
  });
};

// 소셜 로그인 API
const postAuthSocialCallback = async (provider, code) => {
  return await doRequest({
    method: 'post',
    url: apis.auth.social.callback(provider),
    params: { code },
    skipAuth: true,
  });
};

const postAuthSocialSignup = async (params) => {
  return await doRequest({
    method: 'post',
    url: apis.auth.social.signup,
    params: params,
    skipAuth: true,
  });
};

const postAuthSocialVerify = async (token) => {
  return await doRequest({
    method: 'post',
    url: apis.auth.social.verify(token),
    params: {},
    skipAuth: true,
  });
};

// 결제 API
const postSubscribe = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.payment.subscribe}`,
    params: params,
  });
};

const getSubscription = async () => {
  return await doRequest({
    method: 'get',
    url: `${apis.payment.subscription}`,
    params: {},
  });
};

const postCancelSubscription = async () => {
  return await doRequest({
    method: 'post',
    url: `${apis.payment.cancelSubscription}`,
    params: {},
  });
};

const postChangePlanPreview = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.payment.changePlanPreview}`,
    params: params,
  });
};

const postChangePlan = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.payment.changePlan}`,
    params: params,
  });
};

const getPaymentHistory = async (params) => {
  return await doRequest({
    method: 'get',
    url: `${apis.payment.history}`,
    params: params,
  });
};

// 알림 설정 API
const getAlertSetting = async () => {
  return await doRequest({
    method: 'get',
    url: `${apis.alert.setting}`,
    params: {},
  });
};

const postAlertSetting = async (params) => {
  return await doRequest({
    method: 'post',
    url: `${apis.alert.setting}`,
    params: params,
    skipLoading: true,
  });
};

const deleteAlertSetting = async () => {
  return await doRequest({
    method: 'del',
    url: `${apis.alert.setting}`,
    params: {},
  });
};

export {
  // 새로운 Auth API
  postAuthSignup,
  postAuthSignin,
  postAuthCheckEmail,
  postAuthPasswordReset,
  postAuthPasswordChange,
  postAuthSocialCallback,
  postAuthSocialSignup,
  postAuthSocialVerify,
  // 기존 Admin API (유지)
  postAccountSignup,
  postAccountSignin,
  getAccountUser,
  postAccountCheckPassword,
  postAccountUpdatePassword,
  postAccountGeneratePassword,
  postAccountGeneratePasswordToken,
  delAccountDelete,
  getEstateDataList,
  getEstateAddrList,
  getEstateDate,
  // 결제 API
  postSubscribe,
  getSubscription,
  postCancelSubscription,
  postChangePlanPreview,
  postChangePlan,
  getPaymentHistory,
  // 알림 설정 API
  getAlertSetting,
  postAlertSetting,
  deleteAlertSetting,
};
